<div class="ui-g dashboard" style="height: 250px">
  <div style="position: relative; height: 100%; width: 100%" class="task-list supplier-container">
    <p-panel header="Supplier Options" class="">
      <div style="margin-right: 60px">
        <div style="float: left; width: 100%; overflow-y: auto">
          <ul>
            <li
              style="margin-top: 5px; margin-left: 20px; border-bottom: 0px"
              *ngFor="let supplier of suppliers; let i = index"
              (click)="SelectSupplier(supplier)"
              class="supplier-detail"
              [class.selected-row]="supplier == selectSupplier"
            >
              <div style="float: left; width: 150px; text-align: left; margin-right: 3px">
                <p-checkbox
                  name="supplierGroup"
                  value="{{ supplier.id }}"
                  label="{{ supplier.name }}"
                  [(ngModel)]="selectedSuppliers"
                  placeholder="supplier.name"
                  [class.supplier-checkbox]="true"
                >
                </p-checkbox>
              </div>
              <div style="float: left; width: 75px; text-align: left; margin-right: 3px">
                {{ supplier.price | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </div>
              <div style="float: left; width: 135px; text-align: left">
                <p-rating
                  [ngModel]="supplier.rating"
                  readonly="true"
                  stars="5"
                  [cancel]="false"
                ></p-rating>
              </div>
            </li>
          </ul>
        </div>
        <div style="float: right; width: 100px; margin-right: -100px" class="dashboard">
          <div>
            <button
              pButton
              (click)="MoveUp()"
              icon="fa-angle-up"
              style="display: block; margin-left: 10px; margin-top: 10px; width: 25px; height: 25px"
              [disabled]="!selectSupplier || suppliers.indexOf(selectSupplier) == 0"
            ></button>
            <button
              pButton
              (click)="MoveDown()"
              icon="fa-angle-down"
              style="display: block; margin-left: 10px; margin-top: 60px; width: 25px; height: 25px"
              [disabled]="
                !selectSupplier || suppliers.indexOf(selectSupplier) == suppliers.length - 1
              "
            ></button>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </p-panel>
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="IsBusy"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 20%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>
</div>
